
import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { emptyToLine, splitThousands } from "@common/src/utils/common";
import dayjs from "dayjs";
import t from "@common/src/i18n/t";
import { addCurrencySymbol, addCurrencyUnit } from "@common/src/utils/tools";
const employee = namespace("employee");
@Component({})
export default class PushMoneyQueryDetail extends Vue {
  @employee.Action getStaffCommissionDetail;
  emptyToLine = emptyToLine;
  splitThousands = splitThousands;
  addCurrencySymbol = addCurrencySymbol;
  addCurrencyUnit = addCurrencyUnit;
  dayjs = dayjs;
  //计算属性
  get breadData() {
    return [
      { name: t("v210831.commission-query"), path: "/employee/emplyee-push-money/push-money-query" },
      { name: t("v210831.details-of-employee") }
    ];
  }
  showTable = true;
  gridData = [
    {
      name: t("v210831.commission-rule"),
      value: ""
    },
    {
      name: t("v210831.accrued-amount"),
      value: ""
    },
    {
      name: t("v210831.percentage-of-commission"),
      value: ""
    },
    {
      name: t("v210831.commission-weight"),
      value: ""
    },
    {
      name: t("v210831.royalty-amount"),
      value: ""
    }
  ];
  tableData = [
    {
      staffName: "",
      businessName: "",
      businessType: "",
      businessTotal: "",
      commissionAmount: ""
    }
  ];
  pushMoneyDetail = {};
  created() {
    this.init();
  }

  async init() {
    let row;
    if (this.$route.params.row) {
      row = this.$route.params.row;
      localStorage.setItem("pushMoneyDetail", JSON.stringify(row));
    } else {
      row = JSON.parse(localStorage.getItem("pushMoneyDetail"));
    }
    const res = await this.getStaffCommissionDetail({ recordId: row.recordId });
    console.log("[ res ]", res);
    this.tableData = [{ ...res.data }];
    this.pushMoneyDetail = res.data;
    this.gridData[1].value = addCurrencySymbol(res.data.sellingPrice) + "x" + res.data.quantity;
    if (res.data.commissionType === "fixed") {
      this.gridData[0].value = res.data.commissionAmountTypeDesc + res.data.commissionTypeDesc;
      this.gridData[2].name = t("v210831.fixed-commission");
      this.gridData[2].value = addCurrencySymbol(res.data.commissionValue);
      this.gridData[3].value = res.data.commissionWeight + "/" + res.data.businessWeight;
      this.gridData[4].value = addCurrencySymbol(res.data.commissionAmount);
    } else {
      this.gridData[0].value = res.data.commissionAmountTypeDesc + res.data.commissionTypeDesc;
      this.gridData[2].name = t("v210831.percentage-of-commission");
      this.gridData[2].value = res.data.commissionValue + "%";
      this.gridData[3].value = res.data.commissionWeight + "/" + res.data.businessWeight;
      this.gridData[4].value = addCurrencySymbol(res.data.commissionAmount);
    }
  }
  handleLinkPartsDetail(row) {
    let { href } = this.$router.resolve({
      path: `/service/view/${row.orderNo}`
    });
    window.open(href, "_blank");
  }
  orShow() {
    this.showTable = !this.showTable;
  }
}
